const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      const base64Data = base64String.split(",")[1];
      resolve(base64Data);
    };
    reader.onerror = (error) => {
      console.error("Error converting blob to base64:", error);
      reject(error);
    };
    reader.readAsDataURL(blob);
  });
};

const base64ToBlob = async (
  base64String: string,
  mimeType: string
): Promise<Blob> => {
  try {
    const dataUrl = `data:${mimeType};base64,${base64String}`;
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error converting base64 to blob:", error);
    throw error;
  }
};

export { base64ToBlob, blobToBase64 };
